import React from 'react';
import _ from 'lodash';

import {
  activityTemplates,
  PermissionWall,
  permissionUtil,
  useTabSearchParams
} from 'modules';
import {
  styled,
  Box
} from '@mui/material';

import * as AdministratorsTab from './AdministratorsTab/AdministratorsTab';
import * as AssignedPermissionsTab from './AssignedPermissionsTab/AssignedPermissionsTab';
import * as RolesTab from './RolesTab/RolesTab';
import { TabBar } from 'iron-forge-react-modules';



const RootBox = styled(Box)(({ theme }) => ({
  marginRight: theme.spacing(2)
}));

export const AppSettingsActivity: React.FC = () => {
  const [tabId, setTabId] = useTabSearchParams({
    defaultTabId: 'assignedRoles',
    paramName: 'tabId'
  });
  const [hasPermission] = permissionUtil.usePermissions({});



  const tabs: TabBar.ITab[] = React.useMemo(
    () => _.compact([
      hasPermission(['user_view']) ? {
        id: 'users',
        label: "Users"
      } : null,
      hasPermission(['permission_assignRole', 'permission_viewRole', 'user_view']) ? {
        id: 'assignedRoles',
        label: "Assigned Roles"
      } : null,
      hasPermission(['permission_viewRole']) ? {
        id: 'roles',
        label: "Roles"
      } : null
    ]),
    [hasPermission]
  );

  return (
    <activityTemplates.AdminActivityTemplate.FC>
      <TabBar.FC
        tabId={tabId ?? ''}
        onSelectTab={setTabId}
        tabs={tabs} />

      <RootBox>
        {tabId === 'users' && (
          <AdministratorsTab.FC />
        )}

        <PermissionWall.FC requiresPermissions={['permission_assignRole']}>
          {tabId === 'assignedRoles' && (
            <AssignedPermissionsTab.FC />
          )}
        </PermissionWall.FC>

        <PermissionWall.FC requiresPermissions={['permission_viewRole']}>
          {tabId === 'roles' && (
            <RolesTab.FC />
          )}
        </PermissionWall.FC>

      </RootBox>

    </activityTemplates.AdminActivityTemplate.FC>
  );
};
